import { DateTime } from 'luxon'
import { getEventLabel, getEventIcon } from '@/helpers/event-helpers'

export default {
  methods: {
    handleSearch (search) {
      this.search = search
      this.fetchList()
    },
    formatEvent (type) {
      return getEventLabel(type)
    },
    getEventIcon (type) {
      return getEventIcon(type)
    },
    formatDate (date, type) {
      let result = !this.isValidDate(date) && type === 'date' ? 'Open' : ''
      if (this.isValidDate(date) && type === 'date') {
        result = DateTime.fromISO(date).toFormat('dd LLL yyyy')
      }
      if (this.isValidDate(date) && type === 'time') {
        result = DateTime.fromISO(date).toLocaleString(DateTime.TIME_SIMPLE)
      }
      return result
    },
    inHoursMinutes (duration) {
      const hours = Math.floor(duration / 60 / 60)
      const minutes = Math.floor((duration - hours * 60 * 60) / 60)
      return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`
    },
    isValidDate (date) {
      return DateTime.fromISO(date).isValid
    },
    formatIntegrationDate (date, type) {
      let result = !this.isValidDate(date) && type === 'date' ? 'Open' : ''
      if (this.isValidDate(date) && type === 'date') {
        result = DateTime.fromISO(date, { zone: 'gmt' }).toFormat('dd LLL yyyy')
      }
      if (this.isValidDate(date) && type === 'time') {
        result = DateTime.fromISO(date, { zone: 'gmt' }).toFormat('hh:mm:ss ZZZZ')
        result = result.replace('UTC', 'GMT')
      }
      return result
    },
  },
}
